import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'warm' | 'cool' | 'green' | 'dark' | 'black' | 'gradient-dark' | 'gradient-purple' | 'gradient-pink' | 'light-pink' | 'light-purple' | 'light-peach';
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white',
  containerSize = 'lg'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white text-slate-900',
    warm: 'bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 text-slate-900',
    cool: 'bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 text-slate-900',
    green: 'bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 text-slate-900',
    dark: 'bg-gradient-to-br from-purple-100 via-pink-100 to-rose-100 text-slate-900',
    black: 'bg-gradient-to-br from-fuchsia-50 via-pink-50 to-rose-50 text-slate-900',
    'gradient-dark': 'bg-gradient-to-br from-purple-50 via-pink-50 to-fuchsia-50 text-slate-900',
    'gradient-purple': 'bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50 text-slate-900',
    'gradient-pink': 'bg-gradient-to-br from-pink-50 via-rose-50 to-fuchsia-50 text-slate-900',
    'light-pink': 'bg-gradient-to-br from-pink-50 to-rose-50 text-slate-900',
    'light-purple': 'bg-gradient-to-br from-purple-50 to-pink-50 text-slate-900',
    'light-peach': 'bg-gradient-to-br from-orange-50 to-pink-50 text-slate-900'
  };
  const containers = {
    sm: 'max-w-3xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className} relative overflow-hidden`} data-id="element-312">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-fuchsia-200/20 to-pink-200/20 rounded-full blur-3xl pointer-events-none" data-id="element-313"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-purple-200/20 to-pink-200/20 rounded-full blur-3xl pointer-events-none" data-id="element-314"></div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={`mx-auto ${containers[containerSize]} relative z-10`} data-id="element-315">
        {children}
      </motion.div>
    </section>;
}